export default {
  GET_ITEMS(state) {
    return state.subServices
  },

  GET_ITEM(state, id) {
    return state.subServices.find(item => item.id == id)
  },
}
